export class InitAuth {
  static readonly type = '[Auth] Init Auth';
}
export class SignIn {
  static readonly type = '[Auth] Sign In';
}

export class SignOut {
  static readonly type = '[Auth] Sign Out';
}

export class UserSessionExpired {
  static readonly type = '[Auth] User Session Expired';
}

export class FetchUserInfo {
  static readonly type = '[Auth] Fetch UserInfo';
}
/**
 * This action is used to clear the user session data from the store.
 * This is used when the user logs out.
 * This action could used from other states as well to clear their user session related data.
 */
export class ClearUserSessionData {
  static readonly type = '[Auth] Clear User Session Data';
}
